import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild, Output, EventEmitter, NgZone } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BeatListModel } from 'src/app/models/beat-list-model';
import { CartListModel, CartObj } from 'src/app/models/cart-list.model';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { BrowserStorageService } from 'src/app/services/browser-storage/browser-storage.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { CheckExclusiveLic } from 'src/app/pipes/check-exclusive/check-exclusive-exist.pipe';
import { NegotiationService } from 'src/app/services/negotiation/negotiation.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';
import { MobileVerificationFlowService } from 'src/app/services/Auth/mobile-verification-flow.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { GuestCartService } from 'src/app/services/cart/guest-cart.service';
import { GuestCartItem } from 'src/app/models/guest-cart.model';
import TIER_CONFIG from '../../../../../../assets/data/license-tier-config.json';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { CouponService } from 'src/app/services/coupon/coupon.service';
import { WindowRefService } from 'src/app/services/razor-pay-gateway/window-ref.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { BillingAddressPopupComponent } from '../../billing-address-popup/billing-address-popup.component';
import { AddBillingAddressFormComponent } from '../../../billing-addresses/add-billing-address-form/add-billing-address-form.component';
import { BillingAddressService } from 'src/app/services/billing-address/billing-address.service';
import { OtpPageComponent } from '../../otp-page/otp-page.component';

@Component({
  selector: 'ipm-price',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss']
})
export class PriceComponent implements OnInit, OnChanges {
  @Input() priceData: any =  "";
  visible: boolean = false;
  licType: string = "wav";
  position: any = "";
  creditsOption: Array<string> = ["Yes", "No"];
  licenseData:Array<any> = [];
  beatData:any;
  selectedLicData:any;
  isRoyaltyCount:number = 0;
  isNotRoyaltyCount:number = 0;
  totalCount:number  = 0;
  cartListData: Array<CartObj> = [];
  isShowCheckoutBtn: boolean = true;
  @Output() isPlayMusic: EventEmitter<any>  = new EventEmitter();
  @Output() isNegotiation: EventEmitter<any> = new EventEmitter();
  @Output() purchaseEventTrigger: EventEmitter<any> = new EventEmitter();
  @Output() orderSuccessEvent: EventEmitter<any> = new EventEmitter();
  isShowSampleDetails: boolean = false;
  isShowCompareLicense: boolean = false;
  @ViewChild('loginAlertUserPopup', { static: false }) loginAlertUserPopup: TemplateRef<any>;
  @ViewChild('couponAvailablePopup', { static: false }) couponAvailablePopup: TemplateRef<any>;
  @ViewChild('termsCarousel', { static: false }) termsCarousel: CarouselComponent;
  @ViewChild('paymentSuccessPopup', { static: false }) paymentSuccessPopup: TemplateRef<any>;
  isShowAllButtons: boolean = true;
  showCouponPopup: boolean = false;
  availableCouponData: any = null;
  isCouponPopupFlow: boolean = false;
  // NEW: Properties for renderType handling
  renderType: string = '';
  isSoundKit: boolean = false;
  contentType: string = 'beat';
  currentCreditBalance: number = 0;
  isUserLogin: boolean = false;
  isBasicPlan: boolean = false;

  // UI tier cards for the new license modal design
  uiTiers: Array<any> = [];
  activeTierMeta: any = null;
  isShowLicense: boolean = false;
  inlineLicenseData: any = null;
  licenseTerms: Array<{ icon: string; title: string; value: string; description: string }> = [];
  compareLicenseRows: Array<{ label: string; values: Record<string, string>; sellerSlugs?: Array<string> }> = [];
  private termsWheelLocked: boolean = false;
  private termsCenterIndex: number = 0;
  termsCarouselOptions: OwlOptions = {
    center: true,
    responsiveRefreshRate: 0,
    dots: true,
    nav: false,
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    autoWidth: false,
    margin: 14,
    items: 3,
    slideBy: 1,
    responsive: {
      0: { items: 1, margin: 12, stagePadding: 48 },
      480: { items: 3, margin: 12, stagePadding: 40 },
      768: { items: 4, margin: 12, stagePadding: 40 },
      1024: { items: 5, margin: 14, stagePadding: 60 }
    }
  };
  constructor(public commonServices: CommonService,
    private router: Router,
    private browserService: BrowserStorageService,
    private cartService: CartService,
    private beatService: BeatsService,
    public ga4Tracking: Ga4trackingService,
    private checkExclusive: CheckExclusiveLic,
    private negotiationService: NegotiationService,
    private subscriptionService: SubscriptionService,
    private mobileVerificationFlow: MobileVerificationFlowService,
    private guestCartService: GuestCartService,
    private compaginService: CampaignService,
    private couponService: CouponService,
    private winRef: WindowRefService,
    private ngZone: NgZone,
    private authService: AuthService,
    private billingAddressService: BillingAddressService,
    private sanitizer: DomSanitizer) {
    this.position = commonServices.isMobileDisableClick ?? "bottom";
  }

  ngOnInit(): void {
    this.isUserLogin = this.browserService.getSessionData()? true : false;
    this.authService.currentUserDetails.subscribe((userObj: any)  => {
      if (userObj && Object.keys(userObj).length > 0) {
        this.isUserLogin = true;
      } else {
        this.isUserLogin = false;
      }
    });
    this.commonServices.cartDataList.subscribe( (cartsObj: CartListModel) => {
      if (Object.keys(cartsObj).length) {
        this.cartListData = cartsObj.carts
      }
    });
    this.isShowCheckoutBtn = !this.commonServices.isShowConfirmationsDialogBox();
    this.beatService.isUpdateData.subscribe( (beatObj: BeatListModel) => {
      if (beatObj && Object.keys(beatObj).length > 0 && this.beatData._id === beatObj._id) {
        this.beatData.isPlayMusic = beatObj.isPlayMusic;
      }
    });
    this.commonServices.currentCreditBalanceChanges.subscribe((res) => {
      this.currentCreditBalance = res;
    });
    this.subscriptionService.activeSubscription.subscribe((activeSubsResponse: CurrentActivatedPlan) => {
      if (activeSubsResponse && activeSubsResponse.subscriptionTiers) {
        const highestTier = activeSubsResponse.subscriptionTiers[activeSubsResponse.subscriptionTiers.length - 1];
        this.isBasicPlan = highestTier === 'tier0';
      } else {
        this.isBasicPlan = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['priceData']) {
      this.isRoyaltyCount = 0;
      this.isNotRoyaltyCount = 0;
      this.isShowCompareLicense = false;
      this.isShowSampleDetails = false;
      this.isShowLicense = false;
      this.inlineLicenseData = null;
      this.termsCenterIndex = 0;
      this.licenseData = this.priceData?.toggleData;
      this.beatData = this.priceData?.beatData;
      this.licType =  this.priceData?.selectedData?.currentLice;
      this.totalCount =  this.priceData?.totalCount;
      
      // Extract renderType from priceData
      this.renderType = this.priceData?.renderType || '';
      this.isSoundKit = this.renderType === 'soundKit' || this.renderType === 'artistSoundList';
      this.contentType = this.isSoundKit ? 'soundkit' : 'beat';
      
      // For sound kits: Force WAV license and filter to only show WAV
      if (this.isSoundKit) {
        this.licType = 'wav';
        // Only show WAV license for sound kits
        this.licenseData = this.licenseData.filter(lic => lic.slug === 'wav');
        
        // Ensure beatData has the expected structure for sound kits
        if (!this.beatData.cover_picture && this.beatData.coverImageUrl) {
          this.beatData.cover_picture = this.beatData.coverImageUrl;
        }
        if (!this.beatData.created_by && this.beatData.author) {
          this.beatData.created_by = this.beatData.author;
        }
      }
      
      if (this.beatData?.is_used_sample && this.beatData?.used_samples) {
        this.beatData?.used_samples.map((item:any) => {
          if(item.is_royalty_free) {
            this.isRoyaltyCount++;
          } else {
            this.isNotRoyaltyCount++;
          }
        });
      } else {
        this.beatData['used_samples'] = [];
      }
      this.setSelectedData();
      this.uiTiers = this.buildUiTiers();
      this.activeTierMeta = this.getActiveTierMeta();
      this.licenseTerms = this.buildLicenseTerms();
      this.compareLicenseRows = this.buildCompareLicenseRows();

      // fetch populated coupons
      if (this.beatData?.available_coupons && this.beatData.available_coupons.length > 0) {
        const firstCoupon = this.beatData.available_coupons[0];
        if (typeof firstCoupon === 'string') {
          if (this.isUserLogin) {
            const body = {
              filter: { coupon_id: firstCoupon }
            };
            this.couponService.getCouponList(body, false).subscribe(
              (couponsList: any[]) => {
                if (couponsList && couponsList.length > 0) {
                  this.beatData.available_coupons[0] = couponsList[0];
                  this.uiTiers = this.buildUiTiers();
                  this.activeTierMeta = this.getActiveTierMeta();
                  this.licenseTerms = this.buildLicenseTerms();
                  this.compareLicenseRows = this.buildCompareLicenseRows();
                }
              },
              (err: any) => {
                console.error('[PriceComponent] Failed to fetch coupon details:', err);
              }
            );
          } else {
             // For guests, use getGuestCartPreview to fetch populated available_coupons
             const priceId = this.beatData.prices?.[0]?.priceDetails?._id || this.selectedLicData?.priceDetails?._id;
             if (priceId) {
               const items = this.isSoundKit 
                 ? [{ sound_id: this.beatData._id, sound_price: priceId }] 
                 : [{ beat_id: this.beatData._id, beat_price: priceId }];
                 
               this.cartService.getGuestCartPreview(items).subscribe((previewRes: any) => {
                  const cartItem = previewRes?.carts?.[0];
                  const populatedCoupons = this.isSoundKit ? cartItem?.sound?.available_coupons : cartItem?.beat?.available_coupons;
                  if (populatedCoupons && populatedCoupons.length > 0) {
                     this.beatData.available_coupons[0] = populatedCoupons[0];
                     this.uiTiers = this.buildUiTiers();
                     this.activeTierMeta = this.getActiveTierMeta();
                     this.licenseTerms = this.buildLicenseTerms();
                     this.compareLicenseRows = this.buildCompareLicenseRows();
                  }
               }, (err: any) => {
                  console.error('[PriceComponent] Failed to fetch guest preview for coupon details:', err);
               });
             }
          }
        }
      }

      console.log('[PriceComponent:D] uiTiers built:', this.uiTiers.map((t: any) => ({ slug: t.slug, price: t.priceStr })));
      console.log('[PriceComponent:E] activeTierMeta slug:', this.activeTierMeta?.slug);
    }
  }

  setSelectedData() {
    const found = this.licenseData.find((item: any) => item.slug === this.licType);
    if (found) {
      this.selectedLicData = found;
    } else {
      // Fallback: if the current licType slug doesn't match any available license
      // (e.g. older beat data), pick the first non-disabled license
      const fallback = this.licenseData.find((item: any) => !item.isDisable);
      if (fallback) {
        this.selectedLicData = fallback;
        this.licType = fallback.slug;
      }
    }
  }

  private openBillingAddressPopup(hasAddresses: boolean = true) {
    this.commonServices.closePopUp();

    setTimeout(() => {
      if (!this.isUserLogin || !hasAddresses) {
        // For guests or logged in users with no addresses, bypass the list and open the add address form directly
        this.sendBuyNowClickedEvent();
        let className = this.commonServices.getClassName('ipm-address-model');
        this.commonServices.openModel(AddBillingAddressFormComponent, { currentPlanDetails : ""}, className, true);
        
        // Inject Inputs dynamically into the component instance
        const ref: any = this.commonServices.isMobileDisableClick ? this.commonServices.bottomRef : this.commonServices.modelRef;
        const instance = ref?.componentInstance || ref?.instance;
        if (instance) {
          instance.countries = this.commonServices.getCountriesList();
          instance.dialogType = 'buyNowType';
          instance.currentAddressDetails = {};
          instance.isGuestMode = !this.isUserLogin;
          
          if (typeof instance.ngOnInit === 'function') {
            instance.ngOnInit();
          }
        }

        if (this.commonServices.isMobileDisableClick) {
          const sub = this.commonServices.bottomRef.afterDismissed().subscribe((response: any) => {
            this.onCloseModelPopup({ selectedAddress: response });
            sub.unsubscribe();
          });
        } else {
          const sub = this.commonServices.modelRef.afterClosed().subscribe((response: any) => {
            this.onCloseModelPopup({ selectedAddress: response });
            sub.unsubscribe();
          });
        }
      } else {
        let className = this.commonServices.getClassName('ipm-billing-address-popup-model');
        this.commonServices.openModel(BillingAddressPopupComponent, { currentPlanDetails : ""}, className, true);

        if (this.commonServices.isMobileDisableClick) {
          const sub = this.commonServices.bottomRef.afterDismissed().subscribe((response: any) => {
            this.onCloseModelPopup(response);
            sub.unsubscribe();
          });
        } else {
          const sub = this.commonServices.modelRef.afterClosed().subscribe((response: any) => {
            this.onCloseModelPopup(response);
            sub.unsubscribe();
          });
        }
      }
    }, 150);
  }

  private lastOrderId: string = '';
  private guestUserId: string = '';
  private selectedAddress: any = null;
  private isGuestCheckout: boolean = false;

  private sendBuyNowClickedEvent() {
    const userRole = this.browserService.getSessionData() ? (this.browserService.getCurrentRoles() || 'user') : 'guest';

    this.ga4Tracking.sendEvent('buynow_clicked', {
        value: this.selectedLicData?.priceDetails?.final_price || 0,
        currency: 'INR',
        beatName: this.beatData?.title,
        beatId: this.beatData?._id,
        userRole: userRole,
        userId: this.browserService?.getUserId() || 'guest'
    });
  }

  private sendBuyNowInitiatedEvents() {
    const userRole = this.browserService.getSessionData() ? (this.browserService.getCurrentRoles() || 'user') : 'guest';

    this.ga4Tracking.sendEvent('buynow_initiated', {
        value: this.selectedLicData?.priceDetails?.final_price || 0,
        currency: 'INR',
        beatName: this.beatData?.title,
        beatId: this.beatData?._id,
        userRole: userRole,
        userId: this.browserService?.getUserId() || 'guest'
    });

    this.ga4Tracking.sendEvent('checkout_initiated', {
      category: 'Beats',
      label: 'checkout',
      action: 'click',
      userRole: userRole,
      userId: this.browserService?.getUserId() || 'guest',
      value: this.selectedLicData?.priceDetails?.final_price || 0,
      currency: 'INR',
      beatCountInCart: 1
    });

    if (this.beatData?.is_ad) {
      this.compaginService.trackBuyNow(this.beatData, this.selectedLicData?.priceDetails?.final_price || 0, null, userRole).subscribe();
      this.compaginService.trackCheckout(this.beatData, this.selectedLicData?.priceDetails?.final_price || 0, null, userRole).subscribe();
    }
  }

  buyNowFlow() {
    this.isUserLogin = this.browserService.getSessionData() ? true : false;
    let beatPrice = null;
    if (this.isSoundKit) {
      beatPrice = this.beatData?.price?.final_price ?? null;
    } else {
      if (this.beatData?.prices && this.selectedLicData?._id) {
        const priceObj = this.beatData.prices.find((p: any) => p.licence === this.selectedLicData._id);
        beatPrice = priceObj?.final_price ?? null;
      }
    }

    if (this.isSoundKit && (beatPrice === 0 || beatPrice === null)) {
      this.downloadFreeSound();
      return;
    }

    if (this.isUserLogin) {
      this.billingAddressService.getBillingAddress().pipe(take(1)).subscribe( (res: any) => {
         this.commonServices.billingAddressEvent.next(res || []);
         if (res && res.length > 0) {
            this.openBillingAddressPopup(true);
         } else {
            this.openBillingAddressPopup(false);
         }
      }, (err: any) => {
         this.openBillingAddressPopup(true);
      });
    } else {
      this.openBillingAddressPopup(false);
    }
  }

  onBillingAddressSelected(selectedAddress: any) {

    
    if (selectedAddress && selectedAddress.actionCalling === "checkoutType") {
      this.selectedAddress = selectedAddress.currentBillingAddress;
      const couponCode = this.beatData?.available_coupons && this.beatData.available_coupons.length > 0
        ? this.beatData.available_coupons[0].code
        : undefined;
      if (this.isUserLogin) {
        this.executeBuyNow(this.selectedAddress._id, couponCode);
      } else {
        this.executeGuestBuyNow(this.selectedAddress, couponCode);
      }
    }
  }

  onCloseModelPopup(responseType: any) {
    if (responseType && responseType.actionType === 'Close') {
      return;
    }

    if (responseType && responseType.actionType === 'OpenAddForm') {
      let className = this.commonServices.getClassName('ipm-address-model');
      this.commonServices.openModel(AddBillingAddressFormComponent, { currentPlanDetails : ""}, className, true);
      
      const ref: any = this.commonServices.isMobileDisableClick ? this.commonServices.bottomRef : this.commonServices.modelRef;
      const instance = ref?.componentInstance || ref?.instance;
      if (instance) {
        instance.countries = this.commonServices.getCountriesList();
        instance.dialogType = 'buyNowType';
        instance.currentAddressDetails = {};
        instance.isGuestMode = !this.isUserLogin;
        
        if (typeof instance.ngOnInit === 'function') {
          instance.ngOnInit();
        }
      }

      if (this.commonServices.isMobileDisableClick) {
        const sub = this.commonServices.bottomRef.afterDismissed().subscribe((response: any) => {
          this.onCloseModelPopup({ selectedAddress: response });
          sub.unsubscribe();
        });
      } else {
        const sub = this.commonServices.modelRef.afterClosed().subscribe((response: any) => {
          this.onCloseModelPopup({ selectedAddress: response });
          sub.unsubscribe();
        });
      }
      return;
    }

    if (responseType && responseType?.selectedAddress) {
      this.selectedAddress = responseType.selectedAddress;
      const couponCode = this.beatData?.available_coupons && this.beatData.available_coupons.length > 0
        ? this.beatData.available_coupons[0].code
        : undefined;
      if (this.isUserLogin) {
        // If the address was just created (no _id yet), save it first
        if (!this.selectedAddress._id) {
          this.billingAddressService.insertBillingAddress(this.selectedAddress).subscribe(
            (insertRes: any) => {
              const savedAddress = Array.isArray(insertRes?.data) ? insertRes.data[0] : insertRes?.data;
              const savedId = savedAddress?._id || '';
              if (savedId) {
                this.executeBuyNow(savedId, couponCode);
              } else {
                this.commonServices.showToastErrorMessage('Could not save billing address. Please try again.');
              }
            },
            (insertErr: any) => this.commonServices.showToastError(insertErr)
          );
        } else {
          this.executeBuyNow(this.selectedAddress._id, couponCode);
        }
      } else {
        this.executeGuestBuyNow(this.selectedAddress, couponCode);
      }
    }
  }

  private executeBuyNow(addressId: string, couponCode?: string) {
    this.sendBuyNowInitiatedEvents();

    const payload: any = this.isSoundKit ? {
      sound_id: this.beatData._id,
      sound_price: this.selectedLicData.priceDetails._id,
      billing_address_id: addressId
    } : {
      beat_id: this.beatData._id,
      beat_price: this.selectedLicData.priceDetails._id,
      billing_address_id: addressId
    };

    if (couponCode) {
      payload.coupon_code = couponCode;
    }

    this.cartService.buyNow(payload).subscribe((res: any) => {
      if (res.data) {
        const orderData = Array.isArray(res.data) ? res.data[0] : res.data;
        this.lastOrderId = orderData?._id || "";
        this.openPaymentGateway(orderData);
      }
    }, (err) => {
      const errorMsg = err?.error?.message?.toLowerCase() || err?.message?.toLowerCase() || err?.toLowerCase() || '';
      if (errorMsg.includes('already exists in cart')) {
        this.commonServices.showToastErrorMessage('Beat already added to cart.');
        this.router.navigate(['/cart']);
      } else {
        this.commonServices.showToastError(err);
      }
    });
  }

  private executeGuestBuyNow(address: any, couponCode?: string) {
    this.sendBuyNowInitiatedEvents();

    this.isGuestCheckout = true;
    const billing: any = {
      name: address.name || address.legal_name || '',
      email: address.email || '',
      phone: address.phone || '',
      legal_name: address.legal_name || '',
      company_name: address.company_name || '',
      gst_number: address.gst_number || '',
      country: address.country || '',
      state: address.state || '',
      city: address.city || '',
      address: {
        line_1: address.address?.line_1 || '',
        line_2: address.address?.line_2 || ''
      },
      pin_code: address.pin_code || ''
    };

    const payload: any = this.isSoundKit ? {
      sound_id: this.beatData._id,
      sound_price: this.selectedLicData.priceDetails._id,
      billing: billing
    } : {
      beat_id: this.beatData._id,
      beat_price: this.selectedLicData.priceDetails._id,
      billing: billing
    };

    if (couponCode) {
      payload.coupon_code = couponCode;
    }

    this.cartService.guestBuyNow(payload).subscribe((res: any) => {
      if (res.data) {
        const orderData = Array.isArray(res.data) ? res.data[0] : res.data;
        this.lastOrderId = orderData?._id || '';
        this.guestUserId = orderData?.user?._id || orderData?.user || '';
        this.openPaymentGateway(orderData);
      }
    }, (err) => {
      const status = err?.status;
      const errorCode = err?.error?.code || err?.error?.error?.code || '';
      if (status === 409 && errorCode === 'ACCOUNT_EXISTS') {
        this.handleAccountExistsForBuyNow(address, couponCode);
      } else {
        this.commonServices.showToastError(err);
      }
    });
  }

  /**
   * When guest buy-now returns ACCOUNT_EXISTS, trigger OTP sign-in.
   * After successful OTP verification, save the billing address and complete
   * the purchase as an authenticated user.
   */
  private handleAccountExistsForBuyNow(address: any, couponCode?: string) {
    const email = address?.email || '';
    if (!email) {
      this.commonServices.showToastErrorMessage('Email is required to proceed.');
      return;
    }

    const handleOtpClose = (closedWith: any) => {
      if (closedWith === 'signin') {
        sessionStorage.removeItem('guest_otp_payload');
        // User is now logged in — save billing address then complete buy-now
        this.isUserLogin = true;
        const addressPayload = {
          name: this.selectedAddress.name || this.selectedAddress.legal_name || '',
          legal_name: this.selectedAddress.legal_name || this.selectedAddress.name || '',
          company_name: this.selectedAddress.company_name || '',
          gst_number: this.selectedAddress.gst_number || '',
          country: this.selectedAddress.country || '',
          state: this.selectedAddress.state || '',
          city: this.selectedAddress.city || '',
          address: {
            line_1: this.selectedAddress.address?.line_1 || '',
            line_2: this.selectedAddress.address?.line_2 || ''
          },
          pin_code: this.selectedAddress.pin_code || '',
          email: this.selectedAddress.email || '',
          phone: this.selectedAddress.phone || ''
        };

        this.billingAddressService.insertBillingAddress(addressPayload).subscribe(
          (insertRes: any) => {
            const savedAddress = Array.isArray(insertRes?.data) ? insertRes.data[0] : insertRes?.data;
            const savedAddressId = savedAddress?._id || '';
            if (savedAddressId) {
              this.executeBuyNow(savedAddressId, couponCode);
            } else {
              this.commonServices.showToastErrorMessage('Could not save billing address. Please try again.');
            }
          },
          (insertErr: any) => {
            this.commonServices.showToastError(insertErr);
          }
        );
      } else {
        // User cancelled OTP
        const prefilledAddress = address;
        
        let className = this.commonServices.getClassName('ipm-address-model');
        this.commonServices.openModel(AddBillingAddressFormComponent, { currentPlanDetails : ""}, className, true);
        
        const ref: any = this.commonServices.isMobileDisableClick ? this.commonServices.bottomRef : this.commonServices.modelRef;
        const instance = ref?.componentInstance || ref?.instance;
        if (instance) {
          instance.countries = this.commonServices.getCountriesList();
          instance.dialogType = 'buyNowType';
          instance.currentAddressDetails = prefilledAddress || {};
          instance.isGuestMode = true;
          
          if (typeof instance.ngOnInit === 'function') {
            instance.ngOnInit();
          }
        }

        // Subscribe to form submission (Save & Continue)
        if (this.commonServices.isMobileDisableClick) {
          const sub = this.commonServices.bottomRef.afterDismissed().subscribe((res: any) => {
            if (res) this.onBillingAddressSelected({ currentBillingAddress: res, actionCalling: 'checkoutType' });
            sub.unsubscribe();
          });
        } else {
          const sub = this.commonServices.modelRef.afterClosed().subscribe((res: any) => {
            if (res) this.onBillingAddressSelected({ currentBillingAddress: res, actionCalling: 'checkoutType' });
            sub.unsubscribe();
          });
        }
      }
    };

    this.authService.signInWithOtp(email).subscribe(
      (res: any) => {
        const responseData = res?.data ? res.data : res;
        const userData = responseData?.user && Object.keys(responseData.user).length
          ? responseData.user
          : responseData;
        const userId = userData?._id || responseData?._id;

        if (!userId) {
          this.commonServices.showToastErrorMessage('Unable to start verification. Please try signing in manually.');
          return;
        }

        const otpPayload: any = {
          ...userData,
          _id: userId,
          email: email,
          callingForm: 'signin',
          isGuestAccountExists: true
        };
        sessionStorage.setItem('guest_otp_payload', JSON.stringify(otpPayload));

        this.openOtpPopup(otpPayload, handleOtpClose);
      },
      (error: any) => {
        // If rate limited or error occurs, fallback to the previously sent valid OTP if available
        const cachedRaw = sessionStorage.getItem('guest_otp_payload');
        if (cachedRaw) {
          try {
            const cachedPayload = JSON.parse(cachedRaw);
            if (cachedPayload && cachedPayload.email === email) {
              this.openOtpPopup(cachedPayload, handleOtpClose);
              return;
            }
          } catch (e) {}
        }

        this.commonServices.showToastErrorMessage('Could not send OTP. Please try signing in manually.');
      }
    );
  }

  /**
   * Open the OTP verification popup using OtpPageComponent directly.
   * Opens the component as a dialog (not via ng-template) so it works
   * even after the parent price popup has been closed/destroyed.
   */
  private openOtpPopup(otpPayload: any, onClose: (result: any) => void) {
    const className = this.commonServices.getClassName('ipm-otp-model');
    this.commonServices.openModel(OtpPageComponent, otpPayload, className, true);

    // Inject userInfo into the component instance
    const ref: any = this.commonServices.isMobileDisableClick
      ? this.commonServices.bottomRef
      : this.commonServices.modelRef;
    const instance = ref?.componentInstance || ref?.instance;
    if (instance) {
      instance.userInfo = otpPayload;
    }

    if (this.commonServices.isMobileDisableClick) {
      const sub = this.commonServices.bottomRef.afterDismissed().subscribe((res: any) => {
        onClose(res);
        sub.unsubscribe();
      });
    } else {
      const sub = this.commonServices.modelRef.afterClosed().subscribe((res: any) => {
        onClose(res);
        sub.unsubscribe();
      });
    }
  }

  private openPaymentGateway(orderData: any) {
    const options: any = {
      key: environment.rozarPayDevKey,
      currency: 'INR',
      modal: {
        escape: false,
      },
      order_id: orderData?.service_order_id,
      prefill: {
        "name": orderData?.user?.name || orderData?.billing_details?.name,
        "email": orderData?.user?.email || orderData?.billing_details?.email
      }
    };
 
    options.handler = ((response: any, error:any) => {
      options.response = response;
      
      this.ga4Tracking.sendEvent('checkout_completed', {
        category: 'Beats',
        label: 'checkout',
        action: 'click',
        userRole: this.isUserLogin ? (this.browserService?.getCurrentRoles() || 'user') : 'guest',
        userId: this.isUserLogin ? (this.browserService?.getUserId() || 'user') : 'guest',
        checkoutType: this.isUserLogin ? 'user' : 'guest',
        value: orderData?.total || 0,
        currency: 'INR',
        transaction_id: response?.razorpay_payment_id || '',
        order_id: response?.razorpay_order_id || ''
      });

      this.ga4Tracking.sendEvent('Purchase', {
        category: 'Beats',
        label: 'checkout',
        action: 'click',
        userRole: this.isUserLogin ? (this.browserService?.getCurrentRoles() || 'user') : 'guest',
        userId: this.isUserLogin ? (this.browserService?.getUserId() || 'user') : 'guest',
        checkoutType: this.isUserLogin ? 'user' : 'guest',
        value: orderData?.total || 0,
        currency: 'INR',
        transaction_id: response?.razorpay_payment_id || '',
        order_id: response?.razorpay_order_id || ''
      });
      
      this.ga4Tracking.sendEvent('buynow_completed', {
        category: 'Beats',
        label: 'buynow',
        action: 'complete',
        userRole: this.isUserLogin ? (this.browserService?.getCurrentRoles() || 'user') : 'guest',
        userId: this.isUserLogin ? (this.browserService?.getUserId() || 'user') : 'guest',
        value: orderData?.total || 0,
        currency: 'INR',
        num_items: 1
      });

      
      // Fire Campaign Purchase for Ad beats
      if (this.beatData?.is_ad) {
        const userRole = this.isUserLogin ? (this.browserService?.getCurrentRoles() || 'user') : 'guest';
        this.compaginService.trackBuyNowPurchase(this.beatData, orderData?.total || 0, orderData?._id, userRole).subscribe();
        this.compaginService.trackPurchase(this.beatData, orderData?.total || 0, orderData?._id, userRole).subscribe();
      }

      this.ngZone.run(() => {
        if (!this.isUserLogin && this.guestUserId) {
            this.cartService.claimGuestAccount({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature
            }).subscribe((authRes: any) => {
                if (authRes && authRes.access_token) {
                  localStorage.setItem('isGuestCheckoutLogin', 'true');
                  this.authService.setStorageData(authRes);
                  this.authService.currentUserDetails.next(authRes.data.user);
                  
                }
                this.paymentSuccess();
            });
        } else {
            this.paymentSuccess();
        }
      });
    });
    options.modal.ondismiss = (() => {
      this.ngZone.run(() => {
        this.commonServices.showToastErrorMessage('Transaction cancelled');
      });
    });

    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    rzp.on('payment.failed', (response: any) => {
      this.ngZone.run(() => {
        this.commonServices.showToastErrorMessage('Payment Failed');
      });
    });
  }

  paymentSuccess(type: string = "coupon") {
    let messageData: string = "<p>Order Successfully Paid</p><p>Your payment has been confirmed. You can now download your files.</p>";
    let sendData = {
      popType: type,
      orderId : this.lastOrderId ,
      buttonText: "Close",
      message: messageData
    }
    let classNotifyName =  this.commonServices.getClassName('ipm-payment-success-popup-model');
    this.isPaymentSuccessClosed = false;
    this.commonServices.openModel(this.paymentSuccessPopup,sendData,classNotifyName,false, true);
    
    if (this.commonServices.isMobileDisableClick && this.commonServices.bottomRefSecond) {
      const sub = this.commonServices.bottomRefSecond.afterDismissed().subscribe(() => {
        this.closePopup();
        sub.unsubscribe();
      });
    } else if (!this.commonServices.isMobileDisableClick && this.commonServices.modelRefSecond) {
      const sub = this.commonServices.modelRefSecond.afterClosed().subscribe(() => {
        this.closePopup();
        sub.unsubscribe();
      });
    }
  }

  isPaymentSuccessClosed: boolean = false;

  closePopup(event: any = "") {
    if (this.isPaymentSuccessClosed) return;
    this.isPaymentSuccessClosed = true;
    this.commonServices.secondModelClose();
    this.commonServices.firstModelClose();
    this.commonServices.showToastSuccess("Congratulations! your order has been completed.");
    setTimeout(() => {
      this.commonServices.cartDataList.next({});
      sessionStorage.setItem('orderSuccess', 'true');
      if (this.lastOrderId) {
        if (this.isGuestCheckout && this.guestUserId) {
          const stateData = {
            showGuestOtp: true,
            email: this.selectedAddress?.email || '',
            guestUserId: this.guestUserId,
            orderId: this.lastOrderId
          };
          this.router.navigate(['order-successful', this.lastOrderId], { state: stateData });
        } else {
          this.router.navigate(['order-successful', this.lastOrderId]);
        }
      } else {
        this.router.navigate(['orders']);
      }
    }, 500);
  }

  addToCart(isRedirectToCart: boolean = false) {
    let dataLocal = this.browserService.getSessionData();
    if (dataLocal) { 
      const found =  this.cartListData.find( item => item?.beat?._id ===  this.beatData._id);
          
      // Extract the price - handle both beats and sound kits
      let beatPrice = null;
      if (this.isSoundKit) {
        // Sound kits have a single price object
        beatPrice = this.beatData?.price?.final_price ?? null;
      } else {
        // Beats have a prices array
        if (this.beatData?.prices && this.selectedLicData?._id) {
          const priceObj = this.beatData.prices.find(
            (p: any) => p.licence === this.selectedLicData._id
          );
          beatPrice = priceObj?.final_price ?? null;
        }
      }
      
      // NEW: Check if sound kit is free (price is 0 or null)
     if (this.isSoundKit && (beatPrice === 0 || beatPrice === null)) {
      this.downloadFreeSound();
      let eventname = 'checkout_sound_free';
      let attributes: any = {
        category: this.isSoundKit ? 'Sound' : 'Beats',
        label: 'cart',
        action: 'click',
        soundName : this.beatData?.title,
        soundId : this.beatData?._id,
        value: beatPrice,
        licType: this.licType,
        genre: this.beatData?.genre || this.beatData?.genres?.[0],
        userRole: this.browserService?.getCurrentRoles() || 'guest',
        userId : this.browserService?.getUserId() || 'guest'
      };
      this.ga4Tracking.sendEvent(eventname, attributes);
      return;
     }

      let eventname = this.isSoundKit ? "add_to_cart_sound_buy" : "add_to_cart";
      let attributes: any = {
        category: this.isSoundKit ? 'Sound' : 'Beats',
        label: 'cart',
        action: 'click',
        value: beatPrice,
        licType: this.licType,
        genre: this.beatData?.genre || this.beatData?.genres?.[0],
        userRole: this.browserService?.getCurrentRoles() || 'guest',
        userId : this.browserService?.getUserId() || 'guest'
      };
      if(this.isSoundKit){
        attributes['soundName'] = this.beatData?.title;
        attributes['soundId'] = this.beatData?._id;
      }else{
        attributes['beatName'] = this.beatData?.title;
        attributes['beatId'] = this.beatData?._id;
      }
      this.ga4Tracking.sendEvent(eventname, attributes);
      if (found) {
          this.cartService.deleteCartData(found._id).subscribe( res => {
          this.addBeatIntoCart('showChangeMessage', isRedirectToCart);
          }, (error) => {
            this.commonServices.showToastError(error);
          })
      } else {
      this.addBeatIntoCart('', isRedirectToCart);
      }
    } else {
      // Guest user — add to localStorage cart
      this.addToGuestCart(isRedirectToCart);
    }
  }

  /**
   * Download free sound and redirect to orders
   */
  downloadFreeSound() {
    // You'll need to inject SoundKitService in the constructor
    this.cartService.downloadFreeSound(this.beatData._id).subscribe(
      (response: any) => {
        this.orderSuccessEvent.emit("soundKitFree");
      },
      (error: any) => {
        if (this.mobileVerificationFlow.triggerFromError(error, 'download')) {
          return;
        }
        this.commonServices.closePopUp();
        this.commonServices.showToastError(error);
      }
    );
  }

  /**
   * Add beat Into Cart Call Api 
   * According to check 
   * @param messageType : string
   */
  addBeatIntoCart(messageType: string = '', isRedirectToCart: boolean = false) {
    // For sound kits, use sample_id instead of beat_id
    const data: any = this.isSoundKit ? {
      "sound_id": this.beatData._id,
      "sound_price": this.selectedLicData.priceDetails._id
    } : {
      "beat_id": this.beatData._id,
      "beat_price": this.selectedLicData.priceDetails._id
    };

    let InsertAPiCall = this.cartService.insertCartData(data);
    forkJoin([InsertAPiCall]).subscribe( res => {
      this.commonServices.closePopUp();
      this.cartService.getCarts().subscribe( (cartsObj: CartListModel) => {
        if (Object.keys(cartsObj).length) {
          this.commonServices.cartDataList.next(cartsObj);
        }
      });


      const availableCoupons = res[0]?.data?.carts?.[0]?.beat?.available_coupons;

      if (availableCoupons && availableCoupons.length > 0) {
        this.commonServices.suppressCartDropdown = true;
        // Show coupon available popup
        this.handleCouponAvailableFlow(availableCoupons[0], messageType, isRedirectToCart);
      } else {
        // Normal flow - close popup and show success message
        this.commonServices.closePopUp();
        this.reDirectToCart(messageType, isRedirectToCart ? 'go_to_cart' : 'addBeatIntoCart');
      }
      // if (this.beatData?.is_ad) {
      //   this.compaginService.trackAddToCart(this.beatData).subscribe();
      // }
    }, (error) => {
      this.commonServices.closePopUp();
      this.commonServices.showToastError(error);
    });
  }

  /**
   * Add item to guest localStorage cart for non-logged-in users.
   * Fires the same GA4 events as the authenticated flow.
   */
  addToGuestCart(isRedirectToCart: boolean = false): void {
    this.guestCartService.processAddToCart(
      this.beatData,
      this.selectedLicData,
      this.isSoundKit,
      this.licType
    ).subscribe(result => {
      if (result.requiresLogin) {
        this.commonServices.closePopUp();
        this.commonServices.closingPopupWithSendData('login-alert');
        return;
      }

      if (result.availableCoupons && result.availableCoupons.length > 0) {
        this.commonServices.suppressCartDropdown = true;
        // Show coupon available popup
        this.handleCouponAvailableFlow(result.availableCoupons[0], '', isRedirectToCart);
      } else {
        this.commonServices.closePopUp();
        if (result.wasAlreadyInCart) {
          this.reDirectToCart('showChangeMessage', 'addToGuestCart');
        } else {
          this.reDirectToCart('', 'addToGuestCart');
        }

        if (isRedirectToCart) {
          if (this.commonServices.bottomRef) {
            this.commonServices.bottomRef.dismiss();
          }
          this.router.navigate(['/cart']);
        }
      }
    });
  }

  /***
   * Open Alert Model for Non Login user
   */
  openAuthAlertModel() {
    this.commonServices.closePopUp();
    let className = this.commonServices.isMobileDisableClick ? 'mobile-non-login-alert-shared-model' : 'non-login-alert-shared-model';
    this.commonServices.openModel(this.loginAlertUserPopup, {}, className, false);
  }

  onTermsWheel(event: WheelEvent) {
    if (!this.termsCarousel || this.termsWheelLocked) return;

    event.preventDefault();
    this.termsWheelLocked = true;

    if (event.deltaY > 0 || event.deltaX > 0) {
      this.termsCarousel.next();
    } else {
      this.termsCarousel.prev();
    }

    setTimeout(() => {
      this.termsWheelLocked = false;
    }, 340);
  }

  /** Keeps termsCenterIndex in sync with the carousel's real position.
   *  The `translated` event fires after every drag, wheel, or programmatic move. */
  onTermsCarouselTranslated(event: any) {
    // startPosition is the index of the slide that is now centered
    if (event?.startPosition != null) {
      this.termsCenterIndex = event.startPosition;
    }
  }

  onTermSlideClick(index: number, term: { title: string }) {
    if (!this.termsCarousel) return;

    // Already centered — fire the card's action if it has one
    if (index === this.termsCenterIndex) {
      if (term.title === 'Read Full License') {
        this.showSelectedLicense();
      }
      return;
    }

    // A single next()/prev() moves the center by exactly one slide.
    // The user clicked a visible faded slide, which is always adjacent
    // to center, so one step is all we need.
    // For loop carousels, go in whichever direction is shorter.
    const total = this.licenseTerms.length;
    const forward = (index - this.termsCenterIndex + total) % total;
    const backward = (this.termsCenterIndex - index + total) % total;

    if (forward <= backward) {
      this.termsCarousel.next();
    } else {
      this.termsCarousel.prev();
    }
    // termsCenterIndex will be updated by onTermsCarouselTranslated
  }

  onCompareLicenseClick() {
    this.isShowCompareLicense = true;
    
    this.ga4Tracking.sendEvent('click_compare_licpopup', {
      label: 'compare_license',
      action: 'click',
      userRole: this.browserService?.getCurrentRoles() || 'guest',
      userId: this.browserService?.getUserId() || 'guest',
      beatName: this.beatData?.title,
      beatId: this.beatData?._id
    });
  }
  
  onUsedSampleClick() {
    this.isShowSampleDetails = true;
    
    this.ga4Tracking.sendEvent('click_usedsamples_licpopup', {
      label: 'used_samples',
      action: 'click',
      userRole: this.browserService?.getCurrentRoles() || 'guest',
      userId: this.browserService?.getUserId() || 'guest',
      beatName: this.beatData?.title,
      beatId: this.beatData?._id
    });
  }

  onCompareBackClick() {
    this.isShowCompareLicense = false;
  }

  // ── TIER UI HELPERS ────────────────────────────────────────

  /** Static visual config per slug — sourced from license-tier-config.json */
  private tierConfig: Record<string, any> = TIER_CONFIG;

  /** Inline SVG paths keyed by icon name — returns SafeHtml via DomSanitizer */
  getTermIconSvg(name: string, color: string): SafeHtml {
    const stroke = `stroke="${color}"`;
    const base = `width="16" height="16" viewBox="0 0 24 24" fill="none" ${stroke} stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"`;
    const icons: Record<string, string> = {
      mic:       `<svg ${base}><path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><path d="M12 19v3"/></svg>`,
      broadcast: `<svg ${base}><circle cx="12" cy="12" r="2"/><path d="M16.24 7.76a6 6 0 0 1 0 8.49"/><path d="M7.76 16.24a6 6 0 0 1 0-8.49"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M4.93 19.07a10 10 0 0 1 0-14.14"/></svg>`,
      copy:      `<svg ${base}><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>`,
      video:     `<svg ${base}><path d="m22 8-6 4 6 4V8Z"/><rect x="2" y="6" width="14" height="12" rx="2"/></svg>`,
      music:     `<svg ${base}><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></svg>`,
      lockOpen:  `<svg ${base}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 9.9-1"/></svg>`,
      stack:     `<svg ${base}><path d="M12 2 2 7l10 5 10-5-10-5Z"/><path d="m2 17 10 5 10-5"/><path d="m2 12 10 5 10-5"/></svg>`,
      radio:     `<svg ${base}><circle cx="12" cy="12" r="2"/><path d="M4.93 19.07a10 10 0 0 1 0-14.14"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>`,
      crown:     `<svg ${base}><path d="M2 20h20"/><path d="m5 17-2-11 5 4 4-6 4 6 5-4-2 11Z"/></svg>`,
      infinity:  `<svg ${base}><path d="M12 12c-2-2.5-4-4-6-4a4 4 0 0 0 0 8c2 0 4-1.5 6-4Z"/><path d="M12 12c2 2.5 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.5-6 4Z"/></svg>`,
      calendar:  `<svg ${base}><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4"/><path d="M8 2v4"/><path d="M3 10h18"/></svg>`,
      disc:      `<svg ${base}><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></svg>`,
      percent:   `<svg ${base}><path d="M19 5 5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>`,
      gavel:     `<svg ${base}><path d="m14 13-7.5 7.5c-.83.83-2.17.83-3 0a2.12 2.12 0 0 1 0-3L11 10"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>`,
      live:      `<svg ${base}><path d="M2 20h20"/><path d="M6 20V10"/><path d="M18 20V10"/><path d="M12 20V4"/><path d="M9 4h6"/><path d="M3 10h18"/></svg>`,
      nature:    `<svg ${base}><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M8 12h8"/></svg>`,
      compare:   `<svg ${base}><circle cx="12" cy="4" r="1.5"/><circle cx="6" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M12 5.5v5.5"/><path d="M12 11c0 3-2 4-6 4"/><path d="M12 11c0 3 2 4 6 4"/><path d="M6 15v3.5"/><path d="M18 15v3.5"/></svg>`,
      license: `<svg ${base}><path d="M7 3h8l4 4v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z"/><path d="M15 3v4h4"/><path d="m9.5 14 2 2 4-4"/></svg>`,
    };
    const svg = icons[name] || icons['disc'];
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }

  // Known beat license slugs in preferred display order
  private readonly BEAT_SLUGS = ['mp3', 'wav', 'wav_stem', 'exclusive'];

  /** Build uiTiers from current licenseData —
   *  All non-disabled licenses are included.
   *  Known slugs (mp3/wav/wav_stem/exclusive) are sorted in fixed display order;
   *  any unknown slugs (older beats with different slug names) are appended after. */
  buildUiTiers(): Array<any> {
    return this.licenseData
      .filter((lic: any) => !lic.isDisable)
      .sort((a: any, b: any) => {
        const ai = this.BEAT_SLUGS.indexOf(a.slug);
        const bi = this.BEAT_SLUGS.indexOf(b.slug);
        // Known slugs sorted by BEAT_SLUGS order; unknown slugs (-1) go to the end
        if (ai === -1 && bi === -1) return 0;
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      })
      .map((lic: any) => {
        const cfg = this.tierConfig[lic.slug] || {};
        const meta = cfg.meta || {};
        const dbRegularPrice = lic.priceDetails?.regular !== undefined && lic.priceDetails?.regular !== null 
            ? Number(lic.priceDetails.regular) 
            : (lic.priceDetails?.price !== undefined && lic.priceDetails?.price !== null 
                ? Number(lic.priceDetails.price)
                : (lic.price !== undefined && lic.price !== null 
                    ? Number(lic.price) 
                    : (lic.priceDetails?.final_price || 0)));
        const originalPrice = dbRegularPrice;
        let finalPrice = lic.priceDetails?.final_price || 0;
        let hasDiscount = originalPrice > finalPrice;
        /** Diwali sale discount in % (null when the price is not a sale price) */
        let saleOff: number | null = null;
                
        // Platform Sale (Preferred over any other discounts)
        if (this.commonServices.isBeatOnSale(this.beatData) && lic.priceDetails?.final_price_platform_sale !== undefined && lic.priceDetails.final_price_platform_sale < originalPrice) {
            finalPrice = lic.priceDetails.final_price_platform_sale;
            hasDiscount = true;
            saleOff = Math.round((1 - finalPrice / originalPrice) * 100);
        } 
        // Available coupons (only apply if no platform sale is overriding the price)
        else if (this.beatData?.available_coupons && this.beatData.available_coupons.length > 0) {
           const coupon = this.beatData.available_coupons[0];
           if (coupon && typeof coupon === 'object' && coupon.discount) {
               let couponFinalPrice = originalPrice;
               if (coupon.discount.quantifier === 'percentage') {
                   couponFinalPrice = originalPrice - (originalPrice * (coupon.discount.value / 100));
               } else if (coupon.discount.quantifier === 'amount' || coupon.discount.quantifier === 'flat') {
                   couponFinalPrice = originalPrice - coupon.discount.value;
               }
               
               if (couponFinalPrice < finalPrice) {
                   finalPrice = couponFinalPrice;
                   hasDiscount = true;
               }
           }
        }
        
        finalPrice = Math.max(0, finalPrice);

        return {
          slug: lic.slug,
          name: cfg.name || lic.title,
          priceStr: (finalPrice === 0) ? 'Free' : (finalPrice || finalPrice === 0 ? '₹' + Math.round(finalPrice).toLocaleString('en-IN') : ''),
          originalPriceStr: (originalPrice === 0) ? 'Free' : (originalPrice ? '₹' + originalPrice.toLocaleString('en-IN') : ''),
          discountedPriceStr: (finalPrice === 0) ? 'Free' : (finalPrice || finalPrice === 0 ? '₹' + Math.round(finalPrice).toLocaleString('en-IN') : ''),
          hasDiscount: hasDiscount,
          saleOff: saleOff,
          saveStr: saleOff ? '₹' + Math.round(originalPrice - finalPrice).toLocaleString('en-IN') : '',
          formats: cfg.formats || '',
          best: cfg.best || '',
          accent: cfg.accent || '#ffffff',
          accentRgb: cfg.accentRgb || '255,255,255',
          buyBg: cfg.buyBg || '#ffffff',
          buyText: cfg.buyText || '#000000',
          galaxy: cfg.galaxy || '',
          delta: cfg.delta || 'What you get:',
          popular: cfg.popular || false,
          isDisabled: false,
          meta
        };
      });
  }

  /** Diwali sale is live for this beat: Diwali licence cards and total */
  get isSaleLive(): boolean {
    return this.commonServices.isBeatOnSale(this.beatData);
  }

  /** Return the active tier meta based on current licType */
  getActiveTierMeta(): any {
    return this.uiTiers.find((t: any) => t.slug === this.licType) || null;
  }

  /** Build dynamic "What you get" terms for the active license tier */
  buildLicenseTerms(): Array<{ icon: string; title: string; value: string; description: string }> {
    const activeTier = this.getActiveTierMeta();
    const lic = this.selectedLicData?.priceDetails || {};

    if (!activeTier) return [];

    const t = activeTier.meta?.terms || {};
    const isExclusive = activeTier.slug === 'exclusive';

    // ── Dynamic values from API ───────────────────────────────────────────────
    let pubRight: number | null = null;
    if (this.isSoundKit) {
      const skPub = lic.independentArtist?.publishingRights ?? lic.recordLabel?.publishingRights;
      pubRight = skPub != null ? Number(skPub) : null;
    } else {
      pubRight = lic.royalty_in_percentage?.publishing_right != null
        ? Number(lic.royalty_in_percentage.publishing_right)
        : null;
    }

    const pubDesc = pubRight != null
    ? `You keep ${100 - pubRight}% of the publishing rights. The seller retains ${pubRight}%.`
      : 'Publishing rights split will be set by the producer.';

    const recordingsValue = !isExclusive && lic.number_of_recordings
      ? `${lic.number_of_recordings} recording${lic.number_of_recordings > 1 ? 's' : ''}`
      : (t.masterRecordingsValue || '');

    const periodValue = !isExclusive && lic.licence_period_in_year
      ? `${lic.licence_period_in_year} year${lic.licence_period_in_year > 1 ? 's' : ''}`
      : '';

    // ── Build terms list ──────────────────────────────────────────────────────
    const terms: Array<{ icon: string; title: string; value: string; description: string }> = [
      ...(isExclusive ? [{ icon: 'crown', title: 'Beat Removed from Store', value: '', description: t.beatRemovedDesc || '' }] : []),
      { icon: 'disc',      title: 'File Format',       value: activeTier.meta?.format || '',          description: t.fileFormatDesc    || '' },
      { icon: 'broadcast', title: 'Usage Rights',       value: activeTier.meta?.licenseUsage || '',   description: t.usageRightsDesc   || '' },
      ...(!this.isSoundKit ? [{ icon: 'mic', title: 'Master Recordings', value: recordingsValue, description: t.masterRecordingsDesc || '' }] : []),
      { icon: 'percent',   title: 'Publishing Rights',  value: pubRight != null ? `${100 - pubRight}%` : '', description: pubDesc },
      { icon: 'calendar',  title: 'License Period',     value: (this.isSoundKit || isExclusive) ? 'indefinite' : periodValue,  description: this.isSoundKit ? 'Your license remains valid indefinitely — it never expires.' :  t.licensePeriodDesc || '' },
      { icon: 'lockOpen',  title: 'License Nature',     value: activeTier.meta?.nature || '',         description: t.licenseNatureDesc || '' },
      ...(isExclusive && this.priceData?.negotiationAllow
        ? [{ icon: 'gavel', title: 'Negotiable Price', value: '', description: 'Make an offer to the seller.' }]
        : []),
      { icon: 'license', title: 'Read Full License', value: activeTier.name || '', description: 'Click here to read the full license for this tier.' }
    ];

    return terms;
  }

  buildCompareLicenseRows(): Array<{ label: string; values: Record<string, string>; sellerSlugs?: Array<string> }> {
    const rows = [
      {
        label: 'Files you get',
        getValue: (lic: any, tier: any) => tier.meta?.format || tier.formats || lic.title || '-'
      },
      {
        label: 'Distribution copies',
        getValue: (_lic: any, tier: any) => tier.meta?.distribution || 'Unlimited'
      },
      {
        label: 'Audio streaming',
        getValue: () => 'Unlimited'
      },
      {
        label: 'Radio broadcasting',
        getValue: (_lic: any, tier: any) => tier.meta?.radio === 'Unlimited' ? 'Unlimited' : `${tier.meta?.radio || 0} broadcasts`
      },
      {
        label: 'Live performances',
        getValue: (_lic: any, tier: any) => tier.meta?.live === 'Unlimited' ? 'For-profit' : (tier.meta?.live || 'For-profit')
      },
      {
        label: 'Master recordings',
        getValue: (lic: any, tier: any) => tier.slug === 'exclusive'
          ? 'Unlimited'
          : this.formatCompareCount(lic.priceDetails?.number_of_recordings, 'recording')
      },
      {
        label: 'Publishing rights',
        getValue: (lic: any) => this.formatComparePercent(100 - lic.priceDetails?.royalty_in_percentage?.publishing_right)
      },
      {
        label: 'License period',
        getValue: (lic: any, tier: any) => tier.slug === 'exclusive'
          ? 'Indefinite'
          : this.formatCompareYears(lic.priceDetails?.licence_period_in_year)
      },
      {
        label: 'Exclusivity',
        getValue: (_lic: any, tier: any) => tier.meta?.nature || '-'
      }
    ];

    return rows.map((row) => {
      const values: Record<string, string> = {};
      const sellerSlugs: Array<string> = [];

      this.uiTiers.forEach((tier: any) => {
        const lic = this.licenseData.find((item: any) => item.slug === tier.slug) || {};
        values[tier.slug] = row.getValue(lic, tier);

        if (
          ['Master recordings', 'Publishing rights', 'Master rights', 'License period'].includes(row.label) &&
          values[tier.slug] === 'N/A'
        ) {
          sellerSlugs.push(tier.slug);
        }
      });

      return { label: row.label, values, sellerSlugs };
    });
  }

  private formatCompareCount(value: any, singular: string): string {
    const count = Number(value);
    if (!count) return 'N/A';
    return `${count} ${singular}${count > 1 ? 's' : ''}`;
  }

  private formatComparePercent(value: any): string {
    if (value == null || value === '') return 'N/A';
    return `${value}%`;
  }

  private formatCompareYears(value: any): string {
    const years = Number(value);
    if (!years) return 'N/A';
    return `${years} year${years > 1 ? 's' : ''}`;
  }

  // ── END TIER UI HELPERS ─────────────────────────────────────

  closeDialog() {
    this.commonServices.closePopUp();
  }

  onChangeView(event: any) {

    this.licType =  event;
    this.termsCenterIndex = 0;
    this.setSelectedData();
    this.activeTierMeta = this.getActiveTierMeta();
    this.licenseTerms = this.buildLicenseTerms();
    this.compareLicenseRows = this.buildCompareLicenseRows();
    let eventname = this.licType ;
    let attributes: any = {
      category: this.isSoundKit ? 'Sound' : 'Beats',
      label: 'button',
      action: 'click',
      genre: this.isSoundKit ? (this.beatData?.genres?.[0] || '') : this.beatData?.genre,
      userRole: this.browserService?.getCurrentRoles() || 'guest',
      userId : this.browserService?.getUserId() || 'guest'
    };
    this.ga4Tracking.sendEvent(eventname, attributes);
  }

  scrollTierIntoView(event: MouseEvent) {
    if (!this.commonServices.isMobileDisableClick) return;
    const wrapper = event.currentTarget as HTMLElement;
    setTimeout(() => {
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }, 0);
  }

  redirectDetails(beatObject: BeatListModel, type: string = "") {
    this.closeDialog()
    let route: Array<string> = [];
    if (type) {
      // Check if it's a sound kit
      if (type === 'soundkit' || this.isSoundKit) {
        route = [`/sk-${beatObject.serial_number}`]
      } else {
        route = [`/bt-${beatObject.serial_number}`];
        if (this.beatData?.is_ad) {
          this.compaginService.trackClick(beatObject?._id).subscribe();
        }
      }
    } else {
      route = [`/${beatObject.created_by.handle}`];
      if (this.beatData?.is_ad) {
        this.compaginService.trackProducerProfileClick(beatObject,beatObject?.created_by?._id).subscribe();
        this.compaginService.trackFavClick(beatObject);
      }
    }
    this.router.navigate(route)
  }

  playMusic() {
    this.isPlayMusic.next(this.beatData);
  }

  startNewNegotiation() {
    let dataLocal = this.browserService.getSessionData();
    if (dataLocal) { 

      let eventname = "start_negotiation";
      let attributes: any = {
        category: this.isSoundKit ? 'Sound' : 'Beats',
        label: 'button',
        action: 'click',
        userRole: this.browserService?.getCurrentRoles() || 'guest',
        userId : this.browserService?.getUserId() || 'guest'
        
      };
      this.ga4Tracking.sendEvent(eventname, attributes);
      if (!this.priceData?.isShowBeatOwnerError) {
      if (this.priceData?.negotiationObj?.negotiationId &&  this.priceData?.negotiationObj.isActive) {
        this.closeDialog();
        this.negotiationService.addQueryParamsNegotiation(this.priceData?.negotiationObj?.negotiationId, 'b');
      } else {
        let currentBeatExclusive: any = this.checkExclusive.transform(this.beatData.prices);
        if (currentBeatExclusive &&  Object.keys(currentBeatExclusive).length) {
          this.closeDialog();
          let sendData = this.prepareNegotiationData(currentBeatExclusive);
          this.isNegotiation.next(sendData);
        }
      }
      } else {
        this.commonServices.showToastErrorMessage("Negotiating your own beat is not allowed!");
      }
    } else {
      this.commonServices.closingPopupWithSendData('login-alert');
    }
  }

  prepareNegotiationData(currentBeatExclusive: any) {
    let popUpSendData: any = {
      "beatDetails": {
        "_id": this.beatData.id,
        "cover_picture": this.beatData.cover_picture,
        "title": this.beatData.title,
        "serial_number": this.beatData.serial_number,
        "id": this.beatData.id,
        "price": {
          "wav": 0,
          "stem": 0,
          "exclusive": {
            "price": currentBeatExclusive?.exclusiveData?.final_price,
            "publishingPercentage": currentBeatExclusive?.exclusiveData?.royalty_in_percentage?.publishing_right,
            "masterPercentage": currentBeatExclusive?.exclusiveData?.royalty_in_percentage?.master_right,
          }
        }
      },
      "beatOwner": {
        "handle": this.beatData?.created_by?.handle,
        "name": this.beatData?.producer?.store?.general?.name,
        "_id": this.beatData?.created_by?._id,
      },
      "currentRound": "Round 1",
      "negotiationId": this.priceData?.negotiationObj?.negotiationId,
      "currentOfferDetails": {
        "isPosition": "left",
        "isDisabled": false,
        "header": [
          "Original Offer",
          "Counter Offer"
        ],
        "OfferDetails": [
          {
            "label_Name": "License Fee",
            "symbolType": "price",
            "isCounterEnable": false,
            "isAccepted": false,
            "currentOffer": {
              "offeredBy": "",
              "offerDate": "",
              "_id": "",
              "value": currentBeatExclusive?.exclusiveData?.final_price
            },
            "previousOffer": {
              "offeredBy": "",
              "offerDate": "",
              "_id": "",
              "value": ""
            },
            "isValid": true,
          },
          {
            "label_Name": "Publishing Rights",
            "symbolType": "percentage",
            "isCounterEnable": false,
            "isAccepted": false,
            "currentOffer": {
              "offeredBy": "",
              "offerDate": "",
              "_id": "",
              "value": currentBeatExclusive?.exclusiveData?.royalty_in_percentage?.publishing_right
            },
            "previousOffer": {
              "offeredBy": "",
              "offerDate": "",
              "_id": "",
              "value": ""
            },
            "isValid": true,
          },
          {
            "label_Name": "Master Rights",
            "symbolType": "percentage",
            "isCounterEnable": false,
            "isAccepted": false,
            "currentOffer": {
              "offeredBy": "",
              "offerDate": "",
              "_id": "",
              "value": currentBeatExclusive?.exclusiveData?.royalty_in_percentage?.master_right
            },
            "previousOffer": {
              "offeredBy": "",
              "offerDate": "",
              "_id": "",
              "value": ""
            },
            "isValid": true,
          }
        ]
      },
      "tableHeader": [
        "Original Offer",
        "Counter Offer"
      ]
    }
    return popUpSendData;
  }

  reDirectToCart(messageType: string = '', callingFnction: string = '') {
     let messageShow =""
     if(messageType){
      messageShow = "Your license has been updated.";
     } 
     else{
      messageShow =  this.isSoundKit ? "Sound Kits added to your cart successfully." : "Beat added to your cart successfully.";
     }
    if(!this.isCouponPopupFlow){
      this.commonServices.showToastSuccess(messageShow);
      this.isCouponPopupFlow=false;
    }
    if (callingFnction === 'go_to_cart') {
       this.commonServices.showToastSuccess("Coupon applied successfully.");
      setTimeout(() => {
        this.router.navigate(['/cart']);
      }, 100);
    }
   
  }

  handleCouponAvailableFlow(couponData: any, messageType: string, isRedirectToCart: boolean  , ) {
    
    // Store coupon data for the popup
    this.availableCouponData = {
      coupon: couponData,
      isRedirectToCart: isRedirectToCart,
      messageType: messageType
    };
    // Show the coupon popup
    this.showCouponPopup = true;

    // Close the price component
    this.commonServices.closePopUp();

    //show success toast first 
    let messageShow = messageType ? "Your license has been updated." : "Beat added to your cart successfully.";
    this.commonServices.showToastSuccess(messageShow);
    // Open the coupon popup
    let className = this.commonServices.isMobileDisableClick ? 'ipm-mobile-view-ipm-applied-coupon' : 'ipm-applied-coupon-model';

    this.commonServices.openModel(this.couponAvailablePopup, this.availableCouponData, className);
    this.isCouponPopupFlow=true ; 
    // Handle popup close
    if (this.commonServices.isMobileDisableClick) {
      this.commonServices.bottomRef.afterDismissed().subscribe(response => {
        this.showCouponPopup = false;
        if (response === 'go_to_cart' || isRedirectToCart) {
            this.reDirectToCart(messageType, 'go_to_cart');
        }
      });
    } else {
      this.commonServices.modelRef.afterClosed().subscribe(response => {
        this.showCouponPopup = false;
        if (response === 'go_to_cart' || isRedirectToCart) {
          this.reDirectToCart(messageType, 'go_to_cart');
        }
      });
    }
  }

  purchaseCredit() {
    let dataLocal = this.browserService.getSessionData();
    if (dataLocal) {
      let role = this.browserService.getCurrentRoles();
      if (role && role === 'customer') {
        this.commonServices.closePopUp();
        this.commonServices.showToastErrorMessage("customer are not allowed to make purchases.");
        return;
      }
      let eventname = `checkout_initiated_credit_${this.beatData.creditPrice}`;
      let attributes: any = {
        category: 'Sound',
        label: 'soundKits',
        action: 'click',
        soundName : this.beatData?.title,
        soundId : this.beatData?._id,
        value: this.beatData.creditPrice,
        licType: this.licType,
        genre: this.beatData?.genre || this.beatData?.genres?.[0],
        userRole: this.browserService?.getCurrentRoles() || 'guest',
        userId : this.browserService?.getUserId() || 'guest'
      };
      this.ga4Tracking.sendEvent(eventname, attributes);
      let sendData = {
        currentSound: this.beatData,
        currentLic: this.selectedLicData,
        availableCredits: this.currentCreditBalance
      };
      this.purchaseEventTrigger.emit(sendData);
    } else {
      this.commonServices.closingPopupWithSendData('login-alert');
    }
  }

  requestCreditUpgrade() {
    this.commonServices.closingPopupWithSendData('basic-credit-upgrade');
  }

  closeCouponPopup() {
    this.showCouponPopup = false;
    this.commonServices.closePopUp();
  }

  goToCartWithCoupon() {
    this.showCouponPopup = false;
    this.commonServices.closingPopupWithSendData('go_to_cart');
  }
  showSelectedLicense() {
    let cartData: any = {};
    
    // Use sound_price for sound kits, beat_price for beats
    if (this.isSoundKit) {
      cartData.sound_price = {
        licence: {
          _id: this.selectedLicData?._id,
          slug: this.selectedLicData?.slug,
          title: this.selectedLicData?.title
        }
      };
    } else {
      cartData.beat_price = {
        licence: {
          _id: this.selectedLicData?._id,
          slug: this.selectedLicData?.slug,
          title: this.selectedLicData?.title
        }
      };
    }
    
    this.inlineLicenseData = {
      currentBeatData: this.beatData,
      cartData: cartData,
      license: this.selectedLicData?.title,
      contentType: this.isSoundKit ? 'sound' : undefined,
      isNegotiated: false,
      negotiatedPriceDetails: {},
      currentUser: null
    };
    this.isShowLicense = true;
  }
}
